import { createAction } from '@reduxjs/toolkit'
import { WaypointManifestJson, WaypointType } from '../API/InteractableObjectJson'
import AudioController from '../Controllers/AudioController'
import dispatch from '../Utility/dispatchAction'
import InfoLayer from './InfoLayer'
import InteractableObject from './InteractableObject'
import InteractiveLayer from './InteractiveLayer/InteractiveLayer'

export const waypointActionCreator = createAction('Waypoint.interact', (waypoint: Waypoint, action?: string) => ({
    payload: {
        waypoint,
        action,
    },
}))

export const waypointOpenActionCreator = createAction('Waypoint.open', (waypointId: string) => ({
    payload: {
        waypointId,
    },
}))

export default class Waypoint extends InteractableObject {
    type: WaypointType
    locked: boolean

    interactLockedData?: {
        text: string
        audioId: string
    }

    inspectLockedData?: {
        text: string
        audioId: string
    }

    constructor(manifest: WaypointManifestJson, interactiveLayer: InteractiveLayer, infoLayer: InfoLayer) {
        super(manifest, interactiveLayer, infoLayer)

        this.type = manifest.type
        this.locked = manifest.locked

        if (manifest.inspectLocked) {
            this.inspectLockedData = {
                audioId: AudioController.add(manifest.inspectLocked.srcURL),
                text: manifest.inspectLocked.text,
            }
        }

        if (manifest.interactLocked) {
            this.interactLockedData = {
                audioId: AudioController.add(manifest.interactLocked.srcURL),
                text: manifest.interactLocked.text,
            }
        }

        const openHandler = (event: Event) => {
            // @ts-ignore
            if (event.detail.waypointId === this.id) {
                this.unlock()
            }
            removeEventListener('Waypoint.open', openHandler)
        }

        addEventListener('Waypoint.open', openHandler)
    }

    unlock = () => {
        this.locked = false
    }

    commitInteraction = () => {
        dispatch(waypointActionCreator(this, this.interactData?.action))
    }

    inspect = async () => {
        const action = this.locked ? this.inspectLockedData : this.inspectData

        if (action) {
            await AudioController.playActionAudio(action.audioId, action.text)
        }
    }

    interact = async () => {
        if (this.locked) {
            if (this.interactLockedData) {
                await AudioController.playActionAudio(this.interactLockedData.audioId, this.interactLockedData.text)
            }
        } else {
            if (this.interactData) {
                await AudioController.playActionAudio(this.interactData.audioId, this.interactData.text)
            }

            this.commitInteraction()
        }
    }
}
